<template>
  <div class="home">
    <div class="white-area">
      <p class="logo-area">
        <img src="~@/assets/img/svg/logo.svg" alt="" />
      </p>

      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  components: {},
  data() {
    return {
      fieldType: 'password',
      account: '',
      password: '',
      // Store the meta element
      viewport_meta: document.getElementById('viewport-meta'),
      // Define our viewport meta values
      viewports: {
        default: 'width=device-width',
        landscape: 'width=1400'
      }
    };
  },
  created() {
    // 來到這個頁面,viewport設成有手機版的頁面
    this.viewportSet(this.viewport_meta, this.viewports);
  },
  beforeRouteLeave(to, from, next) {
    // 離開這個頁面,viewport設回只有電腦版寬度
    this.viewportSetWideVersion(this.viewport_meta, this.viewports);
    next();
  },
  methods: {
    //查看密碼
    changeToText() {
      this.fieldType = 'text';
    },

    //切換回密碼
    changeToPassword() {
      this.fieldType = 'password';
    },

    viewportSet(viewport_meta, viewports) {
      if (screen.width > 768) {
        viewport_meta.setAttribute('content', viewports.landscape);
      } else {
        viewport_meta.setAttribute('content', viewports.default);
      }
    },
    viewportSetWideVersion(viewport_meta, viewports) {
      viewport_meta.setAttribute('content', viewports.landscape);
    }
  }
};
</script>
